import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Header from './header/Header'
import './carousel.scss'
import CarouselSlider from './Slider/Slider'

export default class Carousel extends Component {
  render() {
    const {data: {title, description, slides, event, eventAction, eventCategory}} = this.props

    return (
      <div id="carousel-component" className="carousel-component">
        {((title && title.length) || (description && description.length)) &&
          <Header title={title} description={description}/>
        }
        <CarouselSlider slides={slides} eventLabels={{event, eventAction, eventCategory}}/>
      </div>
    )
  }
}

Carousel.propTypes = {
  data: PropTypes.shape({
    title: Header.propTypes.title,
    description: Header.propTypes.description,
    slides: CarouselSlider.propTypes.slides,
  }),
}
